/* eslint-disable */

import { rootApi } from '../rootApi';

export const preStockInspectionApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getAllPreStockInspection: builder.query({
            query: (params) => {
                return {
                    url: 'v1/prestockins/getall',
                    method: 'POST',
                    body: {
                        pageNumber: 1,
                        pageSize: 100,
                        ...params // filtreleri buraya yay
                    }
                };
            },
            // Extract data array from the nested response structure
            transformResponse: (response) => {
                // Check if response has the expected structure with data property
                if (response && typeof response === 'object') {
                    if (response.data && Array.isArray(response.data.preStockInsGetListQueryItems)) {
                        return response.data;
                    }

                    // If response itself is an array, return it directly
                    if (Array.isArray(response)) {
                        return response;
                    }
                    return { preStockInsGetListQueryItems: [], totalCount: 0, statusCounts: [] };
                }

                return [];
            },
            // Keep track of API state for debugging
            onQueryStarted: async (arg, { queryFulfilled }) => {
                try {
                    const result = await queryFulfilled;
                } catch (error) {}
            },
            providesTags: ['PreStockInspection']
        }),

        createPreStockInspection: builder.mutation({
            query: (data) => ({
                url: 'v1/prestockins/create',
                method: 'POST',
                body: data
            }),
            invalidatesTags: ['PreStockInspection']
        }),

        getAllQuestion: builder.query({
            query: (params) => {
                return {
                    url: 'v1/prestockins/getallquestions',
                    method: 'GET',
                    params: {
                        LanguageId: params?.languageId || 1  
                    }
                };
            },
            // Extract data array from the nested response structure
            transformResponse: (response) => {
                // Check if response has the expected structure with data property
                if (response && typeof response === 'object') {
                    if (response.data && Array.isArray(response.data)) {
                        return response.data;
                    }

                    // If response itself is an array, return it directly
                    if (Array.isArray(response)) {
                        return response;
                    }
                }

                // Fallback: return empty array if structure doesn't match
                return [];
            },
            // Keep track of API state for debugging
            onQueryStarted: async (arg, { queryFulfilled }) => {
                try {
                    const result = await queryFulfilled;
                } catch (error) {}
            },
            providesTags: ['PreApproval']
        }),

        getByIdPreStockInspections: builder.query({
            query: (inspectionId) => {
                return {
                    url: 'v1/prestockins/getbyid',
                    method: 'GET',
                    params: {
                        InspectionId: inspectionId
                    }
                };
            },

            // Extract data array from the nested response structure
            transformResponse: (response) => {
                // Eğer response.data bir object ise, onu döndür
                if (response && typeof response === 'object' && response.data) {
                    return response.data; // ✅ Senin istediğin veri bu
                }

                // Fallback: boş nesne
                return {};
            },

            onQueryStarted: async (arg, { queryFulfilled }) => {
                try {
                    const result = await queryFulfilled;
                } catch (error) {}
            },
            providesTags: (result, error, id) => [{ type: 'PreStockInspection', id }]
        }),

        updatePreStockInspection: builder.mutation({
            query: (data) => {
                return {
                    url: 'v1/prestockins/update',
                    method: 'PUT',

                    body: data
                };
            },
            invalidatesTags: (result, error, arg) => [{ type: 'PreStockInspection', id: arg.id }]
        }),

        checkVafExists: builder.query({
            query: (chassisNo) => ({
                url: 'v1/prestockins/checkvafexists',
                method: 'GET',
                params: { chassisNo }
            }),
            transformResponse: (response) => ({
                isSuccess: response?.isSuccessful,
                errorMessage: response?.errorMessage || '',
                exists: response?.data === true
            })
        }),

        sentToKarsan: builder.mutation({
            query: (id) => ({
                url: 'v1/prestockins/sendtokarsan',
                method: 'PUT',
                body: {
                    id
                }
            }),
            invalidatesTags: ['PreStockInspection']
        }),
        getChassisListForPSI: builder.query({
            query: () => ({
                url: 'v1/prestockins/getchassisno',
                method: 'GET'
            }),
            transformResponse: (response) => {
                if (response?.data && Array.isArray(response.data)) {
                    return response.data.map((item) => ({
                        id: item.id,
                        chassisNo: item.chassisNo
                    }));
                }
                return [];
            },
            providesTags: ['Chassis'],
            onQueryStarted: async (arg, { queryFulfilled }) => {
                console.log('🚀 getChassisList started');
                try {
                    const result = await queryFulfilled;
                    console.log('✅ Chassis list fetched:', result);
                } catch (error) {
                    console.error('❌ Error fetching chassis list:', error);
                }
            }
        }),

        getPreStockInspectionHistory: builder.query({
            query: ({ id, pageSize = 10, pageNumber = 0, languageId = 1 }) => ({
                url: `v1/prestockins/gethistorybyid?Id=${id}&PageSize=${pageSize}&PageNumber=${pageNumber}&LanguageId=${languageId}`,
                method: 'GET'
            }),
            transformResponse: (response) => {
                if (response && response.data && Array.isArray(response.data.items)) {
                    return {
                        items: response.data.items,
                        totalCount: response.data.totalCount
                    };
                }
                return { items: [], totalCount: 0 };
            },
            providesTags: (result, error, { id }) => [{ type: 'PreStockInspection', id: `history-${id}` }]
        }),
        exportPreStockInspectionToExcel: builder.query({
    query: (params) => ({
        url: 'v1/prestockins/exporttoexcel',
        method: 'POST',
        body: {
            status: params.Status ?? null,
            inspectorName: params.InspectorName ?? null,
            inspectorTitle: params.InspectorTitle ?? null,
            vin: params.Vin ?? null,
            stockInDate: params.StockInDate ?? null,
            inspectionDate: params.InspectionDate ?? null,
            dealerId: params.DealerId ?? null,
            startDate: params.startDate ?? null,
            endDate: params.endDate ?? null,
            LanguageId: params.LanguageId,
            compressionType: params.compressionType ?? 0
        }
    }),
    transformResponse: (response) => {
        if (response?.isSuccessful && response?.data) {
            const { fileBase64, fileName, contentType, recordCount, fileSize, isCompressed, compressionType } = response.data;
            return { fileBase64, fileName, contentType, recordCount, fileSize, isCompressed, compressionType };
        }
        throw new Error(response?.errorMessage || 'Export failed');
    }
}),
    })
});

export const {
    useGetAllPreStockInspectionQuery,
    useCreatePreStockInspectionMutation,
    useGetAllQuestionQuery,
    useGetByIdPreStockInspectionsQuery,
    useUpdatePreStockInspectionMutation,
    useCheckVafExistsQuery,
    useSentToKarsanMutation,
    useGetChassisListForPSIQuery,
    useGetPreStockInspectionHistoryQuery,
    useLazyExportPreStockInspectionToExcelQuery
} = preStockInspectionApi;
